/**
 * Official-service auth client — same Telegram login flow as pioneer-event
 * (carry-over user mapping); copied from apps/pioneer-event/src/lib/auth.ts.
 */
import { createAuthClient } from "better-auth/react";
import { genericOAuthClient } from "better-auth/client/plugins";

function resolveAuthBaseUrl(): string | undefined {
  const configured = import.meta.env.VITE_AUTH_BASE_URL?.trim();
  if (configured) return configured.replace(/\/+$/, "");
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return "http://localhost:8787";
    }
  }
  return typeof window !== "undefined" ? window.location.origin : undefined;
}

export const authClient = createAuthClient({
  baseURL: resolveAuthBaseUrl(),
  plugins: [genericOAuthClient()],
  fetchOptions: { credentials: "include" },
});

/** OAuth 복귀 URL — query/hash 없이 origin + path 만 사용 */
export function authCallbackUrl(path = "/") {
  if (typeof window === "undefined") return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${window.location.origin}${normalized}`;
}

export async function clearLegacyAuthCookies(): Promise<void> {
  const base = resolveAuthBaseUrl();
  if (!base) return;
  await fetch(`${base}/api/auth/clear-legacy-cookies`, { credentials: "include" });
}

export async function signInWithTelegram(callbackPath = "/") {
  await clearLegacyAuthCookies();
  await authClient.signOut();
  const callbackURL = authCallbackUrl(callbackPath);
  const { error } = await authClient.signIn.oauth2({
    providerId: "telegram",
    callbackURL,
    errorCallbackURL: callbackURL,
  });
  if (error) {
    throw new Error(error.message || "Telegram sign-in failed");
  }
}
